module.exports = __webpack_public_path__ + "img/jr2.873cc25f.png";